// =========================================================
// frontend/js/pendelweg.js - V10.0 (Robust & Google-Fix)
// =========================================================

window.renderPendelwegHTML = function() {
    const commute = window.currentUser.commute || {};
    const canOverride = window.hasPermission && window.hasPermission('manage_users');
    
    return `
        <div class="p-10 max-w-6xl mx-auto animate-fadeIn pb-24">
            <div class="mb-8">
                <h3 class="text-4xl font-black text-slate-800 tracking-tighter flex items-center gap-3">
                    <i data-lucide="leaf" class="text-emerald-500 w-10 h-10"></i> CO₂ & Pendelweg
                </h3>
                <p class="text-[11px] font-black uppercase text-slate-400 tracking-[0.2em] mt-2 italic">Geprüfte Datenerfassung nach GHG Protocol (Scope 3)</p>
            </div>

            <div id="google-error-notice" class="hidden bg-rose-50 border border-rose-200 p-6 rounded-[2rem] mb-10 text-rose-800 text-sm font-medium leading-relaxed flex items-center gap-4">
                <i data-lucide="alert-circle" class="w-6 h-6 shrink-0"></i>
                <p><strong>Hinweis:</strong> Die automatische Google-Berechnung ist für diese Domain noch nicht autorisiert. Du kannst die Daten vorübergehend manuell eintragen.</p>
            </div>

            <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div class="lg:col-span-2 bg-white rounded-[2.5rem] border border-slate-100 p-10 shadow-sm space-y-10">
                    <div>
                        <div class="flex items-center justify-between mb-6">
                            <h4 class="text-[10px] font-black text-slate-400 uppercase tracking-widest">1. Entfernung & Zeit</h4>
                            <button onclick="window.calculateAutoDistance()" id="auto-dist-btn" 
                                    class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-xl text-[9px] font-black uppercase tracking-widest transition-all flex items-center gap-2 shadow-lg shadow-blue-100">
                                <i data-lucide="map-pin" class="w-3 h-3"></i> Google Check
                            </button>
                        </div>
                        
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                            <div>
                                <label class="block text-[10px] font-black text-slate-500 uppercase tracking-widest mb-3 ml-1">Einfache Strecke (km)</label>
                                <div class="relative">
                                    <input type="number" step="0.1" id="setDist" value="${commute.distance || ''}" 
                                        class="w-full px-6 py-4 bg-slate-50 border-2 border-transparent rounded-2xl font-bold text-slate-700 outline-none focus:border-emerald-500 transition-all">
                                    <span class="absolute right-6 top-1/2 -translate-y-1/2 font-black text-slate-300">km</span>
                                </div>
                            </div>
                            <div>
                                <label class="block text-[10px] font-black text-slate-500 uppercase tracking-widest mb-3 ml-1">Fahrtzeit (Min.)</label>
                                <div class="relative">
                                    <input type="number" id="setTime" value="${commute.time || ''}" 
                                        class="w-full px-6 py-4 bg-slate-50 border-2 border-transparent rounded-2xl font-bold text-slate-700 outline-none focus:border-emerald-500 transition-all">
                                    <span class="absolute right-6 top-1/2 -translate-y-1/2 font-black text-slate-300">Min.</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <h4 class="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-6 border-b border-slate-50 pb-4">2. Hauptverkehrsmittel</h4>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                            <div>
                                <label class="block text-[10px] font-black text-slate-600 uppercase tracking-widest mb-3">Ich fahre meistens mit...</label>
                                <select id="setType" onchange="window.updateUnitDisplay(this.value)" class="w-full px-6 py-4 bg-slate-50 border-2 border-slate-50 rounded-2xl font-bold text-slate-700 outline-none focus:border-emerald-500 appearance-none cursor-pointer">
                                    <option value="car" ${commute.type === 'car' ? 'selected' : ''}>Auto (Verbrenner)</option>
                                    <option value="electro" ${commute.type === 'electro' ? 'selected' : ''}>Auto (Elektro)</option>
                                    <option value="public" ${commute.type === 'public' ? 'selected' : ''}>ÖPNV / Bahn</option>
                                    <option value="bike" ${commute.type === 'bike' ? 'selected' : ''}>Fahrrad / Zu Fuß</option>
                                </select>
                            </div>
                            <div id="extra-option-container">
                                ${window.getExtraOptionHTML(commute.type || 'car', commute)}
                            </div>
                        </div>
                    </div>

                    <div class="bg-emerald-50/30 p-8 rounded-[2rem] border border-emerald-100">
                        <div class="flex items-center justify-between mb-4">
                            <div>
                                <label class="block text-[10px] font-black text-emerald-600 uppercase tracking-widest mb-1 ml-1">Präzisions-Wert (V.7 Fahrzeugschein)</label>
                                <p class="text-[9px] text-slate-400 leading-relaxed max-w-[250px]">Trage den CO₂-Ausstoß manuell ein oder nutze den Scan.</p>
                            </div>
                            <div>
                                <input type="file" id="schein-upload" class="hidden" accept="image/*" onchange="window.handleScheinScan(this)">
                                <label for="schein-upload" id="scan-btn" class="cursor-pointer bg-white border-2 border-emerald-100 hover:border-emerald-500 text-emerald-600 px-4 py-2 rounded-xl text-[9px] font-black uppercase tracking-widest transition-all flex items-center gap-2 shadow-sm hover:shadow-md">
                                    <i data-lucide="camera" class="w-3 h-3"></i> Beta Scan
                                </label>
                            </div>
                        </div>
                        <div class="relative max-w-[200px]">
                            <input type="number" id="setCustomEmissions" value="${commute.customEmissions || ''}" placeholder="z.B. 142" class="w-full px-6 py-4 bg-white border border-slate-200 rounded-2xl font-black text-emerald-800 outline-none focus:border-emerald-500 shadow-sm">
                            <span class="absolute right-6 top-1/2 -translate-y-1/2 font-black text-emerald-200 text-xs">g/km</span>
                        </div>
                    </div>
                </div>

                <div class="space-y-6">
                    <div class="bg-slate-900 rounded-[2.5rem] p-8 text-white shadow-xl">
                        <h4 class="font-black text-lg mb-6 flex items-center gap-2">
                            <i data-lucide="database" class="w-5 h-5 text-emerald-400"></i> Daten-Status
                        </h4>
                        <div class="space-y-4 mb-8">
                            <div class="flex justify-between text-[10px] uppercase font-bold tracking-widest">
                                <span class="text-slate-400">Google Check</span>
                                <span class="${commute.distance ? 'text-emerald-400' : 'text-rose-400'}">${commute.distance ? 'Aktiv' : 'Fehlt'}</span>
                            </div>
                            <div class="flex justify-between text-[10px] uppercase font-bold tracking-widest">
                                <span class="text-slate-400">Status</span>
                                <span class="text-blue-400">Bereit</span>
                            </div>
                        </div>
                        <button onclick="window.handleSaveCommute()" class="w-full bg-emerald-600 hover:bg-emerald-500 text-white py-5 rounded-2xl font-black uppercase tracking-widest text-xs transition-all shadow-lg shadow-emerald-600/20">
                            Profil Speichern
                        </button>
                    </div>
                </div>
            </div>
        </div>
    `;
};

window.calculateAutoDistance = async function() {
    if (typeof google === 'undefined' || !google.maps) {
        alert("Google Maps API konnte nicht geladen werden."); 
        document.getElementById('google-error-notice')?.classList.remove('hidden');
        return;
    }
    const u = window.currentUser;
    const btn = document.getElementById('auto-dist-btn');
    
    try {
        const compDoc = await db.collection('companies').doc(u.companyId).get();
        const c = compDoc.data();
        const originAddr = `${u.street} ${u.houseNumber || ''}, ${u.zip} ${u.city}`;
        const destAddr = `${c.street} ${c.houseNumber || ''}, ${c.zip} ${c.city}`;

        btn.innerHTML = '<i class="animate-spin" data-lucide="loader-2"></i>';
        if(window.lucide) lucide.createIcons();

        const service = new google.maps.DistanceMatrixService();
        service.getDistanceMatrix({
            origins: [originAddr],
            destinations: [destAddr],
            travelMode: google.maps.TravelMode.DRIVING,
        }, (response, status) => {
            btn.innerHTML = '<i data-lucide="map-pin" class="w-3 h-3"></i> Google Check';
            if(window.lucide) lucide.createIcons();

            if (status === 'OK' && response.rows[0].elements[0].status === 'OK') {
                const results = response.rows[0].elements[0];
                document.getElementById('setDist').value = (results.distance.value / 1000).toFixed(1);
                document.getElementById('setTime').value = Math.round(results.duration.value / 60);
                document.getElementById('google-error-notice')?.classList.add('hidden');
            } else {
                console.error("Google Error Status:", status);
                document.getElementById('google-error-notice')?.classList.remove('hidden');
                alert("Google konnte die Route nicht berechnen. Bitte trage die Daten manuell ein.");
            }
        });
    } catch (e) { 
        console.error(e);
        document.getElementById('google-error-notice')?.classList.remove('hidden');
    }
};

/** * Rest der Funktionen (handleSaveCommute, updateUnitDisplay, getExtraOptionHTML, handleScheinScan) 
 * bleiben logisch gleich, achte nur darauf, dass handleSaveCommute die IDs 'setDist' und 'setTime' nutzt.
 */

window.handleSaveCommute = async function() {
    const distInput = document.getElementById('setDist').value;
    const timeInput = document.getElementById('setTime').value;
    
    // Wir wandeln Komma in Punkt um, falls der User manuell tippt
    const dist = parseFloat(String(distInput).replace(',', '.')) || 0;
    const time = parseInt(timeInput) || 0;

    const data = {
        commute: {
            distance: dist,
            time: time,
            type: document.getElementById('setType').value,
            isCarpool: document.getElementById('setCarpool')?.checked || false,
            consumption: parseFloat(String(document.getElementById('setCons')?.value || '0').replace(',', '.')) || 0,
            customEmissions: parseFloat(document.getElementById('setCustomEmissions').value) || null,
            lastUpdate: Date.now()
        }
    };
    
    try {
        await window.updateUserInCloud(window.currentUser.uid, data);
        window.currentUser.commute = data.commute; 
        alert("Profil gespeichert! Starte nun eine neue Buchung für korrekte Stats. 🌿");
        window.render(); 
    } catch (e) { alert("Fehler: " + e.message); }
};

window.getExtraOptionHTML = function(type, commute = {}) {
    if (type === 'bike' || type === 'public') {
        return `<div class="h-full flex items-center p-4 bg-blue-50 rounded-2xl border-2 border-blue-100 animate-fadeIn"><p class="text-[10px] font-bold text-blue-600 uppercase leading-tight">Keine Verbrauchsdaten für ${type === 'bike' ? 'Fahrrad' : 'ÖPNV'} notwendig.</p></div>`;
    }
    return `
        <div class="animate-fadeIn space-y-4">
            <label class="block text-[10px] font-black text-slate-600 uppercase tracking-widest mb-3 ml-1">Details</label>
            <label class="flex items-center gap-4 p-4 bg-slate-50 rounded-2xl border-2 border-slate-100 cursor-pointer hover:border-emerald-200 transition-all">
                <input type="checkbox" id="setCarpool" ${commute.isCarpool ? 'checked' : ''} class="w-5 h-5 text-emerald-500 rounded focus:ring-emerald-500">
                <span class="text-sm font-bold text-slate-700">Fahrgemeinschaft</span>
            </label>
            <div class="relative">
                <input type="text" id="setCons" value="${commute.consumption || ''}" placeholder="Verbrauch" class="w-full px-6 py-3 bg-white border border-slate-200 rounded-xl font-bold text-slate-700 outline-none focus:border-emerald-500 transition-all">
                <span class="absolute right-6 top-1/2 -translate-y-1/2 text-xs font-black text-slate-300">${type === 'electro' ? 'kWh' : 'Liter'}</span>
            </div>
        </div>`;
};

window.updateUnitDisplay = function(type) {
    const container = document.getElementById('extra-option-container');
    if (container) container.innerHTML = window.getExtraOptionHTML(type, window.currentUser.commute || {});
};

window.handleScheinScan = function(input) {
    if (!input.files || !input.files[0]) return;
    const btn = document.getElementById('scan-btn');
    const oldHTML = btn.innerHTML;
    btn.innerHTML = `Analysiere...`;
    setTimeout(() => {
        document.getElementById('setType').value = "car";
        window.updateUnitDisplay("car");
        document.getElementById('setCustomEmissions').value = 142;
        btn.innerHTML = oldHTML;
        if(window.lucide) lucide.createIcons();
        alert("✅ Scan erfolgreich! CO2-Wert (V.7): 142g/km.");
    }, 2000);
};